import { useLang } from '../lib/lang';
import { IMAGES } from '../content/constants';
import { Page, HeroShell, Reveal } from '../components/motion';
import { SkeletonGrid, CTASection, PageSection } from '../components/blocks';

const INTEGRATED_IMAGES = [IMAGES.fibre, IMAGES.serverOps];

export default function DataCentre() {
  const { t } = useLang();
  const c = t.dc;
  return (
    <Page meta={{ ...t.meta.dc, lang: t.lang }}>
      <HeroShell testId="dc-hero" overline={c.hero.overline} lines={c.hero.lines} sub={c.hero.sub} image={IMAGES.fibre} />

      <PageSection overline={c.integrated.overline} testId="dc-integrated">
        <div className="grid md:grid-cols-2 gap-6">
          {c.integrated.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div data-testid={`dc-integrated-${item.name.toLowerCase()}`} className="group border border-white/10 bg-surface hover:border-volt/60 transition-colors duration-500 overflow-hidden">
                <div className="relative overflow-hidden">
                  <img src={INTEGRATED_IMAGES[i]} alt={item.name} className="img-treated w-full aspect-[16/9] object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-surface to-transparent" />
                </div>
                <div className="p-8 md:p-10 -mt-10 relative">
                  <h3 className="font-display text-3xl md:text-4xl font-black tracking-tight text-white group-hover:text-volt transition-colors duration-500">{item.name}</h3>
                  <p className="mt-4 text-sm text-zinc-400 leading-relaxed">{item.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </PageSection>

      <PageSection overline={c.bento.overline} testId="dc-bento" className="bg-surface/40">
        <SkeletonGrid items={c.bento.items} cols="md:grid-cols-2" numbered testId="dc-bento-grid" />
      </PageSection>

      <CTASection title={c.cta} btn={c.cta} />
    </Page>
  );
}
